export enum IncomeEnum {
    ZERO = 0,
    QUATROCENTOS = 499,
    QUINHENTOS = 500,
    MILECEM = 1199,
    MILDUZENTOS = 1200,
    TRESMIL = 3999,
    QUATROMIL = 4000,
    SEISMIL = 6999,
    SETEMIL = 7000,
    NOVEMIL = 9999,
    DEZMIL = 10000,
}

export enum IncomePhaseEnum {
    FAIXA_1 = 'de 0 a 499',
    FAIXA_2 = 'de 500 a 1199',
    FAIXA_3 = 'de 1200 a 3999',
    FAIXA_4 = 'de 4000 a 6999',
    FAIXA_5 = 'de 7000 a 9999',
    FAIXA_6 = 'acima de 10000',
}